import { Facebook, Instagram, Phone } from "lucide-react";
import { NAV_LINKS, SOCIALS } from "@/data";
import { Logo } from "@/components/Logo";
import { FooterQr } from "@/components/FooterQr";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const SOCIAL_ICONS = { Facebook, Instagram, Viber: Phone };

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-white border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <Logo className="h-10 w-12" ringColor="#FFFFFF" />
              <span className="font-heading font-extrabold text-xl">Φυσική Επιλογή</span>
            </div>
            <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
              Φροντιστήριο Μέσης Εκπαίδευσης. Προετοιμασία Γυμνασίου & Λυκείου για τις Πανελλήνιες Εξετάσεις,
              με μεθοδικότητα και ανθρώπινη προσέγγιση.
            </p>
            <FooterQr url="https://fysikiepilogi.gr/members" label="Περιοχή Μελών — για μαθητές, γονείς & καθηγητές" />
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/40 mb-4">Πλοήγηση</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-sm text-white/70 hover:text-accent transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/40 mb-4">Επικοινωνία</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li>25ης Μαρτίου 64, Πετρούπολη</li>
              <li>210.50.65.275</li>
              <li>fysikiepilogi.01@gmail.com</li>
              <li>www.fysikiepilogi.gr</li>
              <li>Δευ–Παρ: 15:00 – 21:30</li>
              <li>Σαβ–Κυρ: 09:00 – 14:00</li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.platform];
                return (
                  <a
                    key={s.platform}
                    href={s.url}
                    data-testid={`social-${s.platform.toLowerCase()}`}
                    title={`${s.platform} — ${s.handle}`}
                    className="h-10 w-10 flex items-center justify-center border border-white/15 rounded-sm text-white/70 hover:bg-accent hover:text-white hover:border-accent transition-colors"
                  >
                    <Icon className="h-4 w-4" strokeWidth={1.5} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} Φυσική Επιλογή — Όλα τα δικαιώματα διατηρούνται
          </p>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="font-mono-accent text-[10px] uppercase tracking-widest text-white/40 hover:text-accent transition-colors"
          >
            Διαχείριση
          </a>
        </div>
      </div>
    </footer>
  );
}
